import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import Card from "components/Card/Card.js";
import CardAvatar from 'components/Card/CardAvatar';
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import ClassAttendanceTable from 'components/ClassAttendanceTable';
import Button from 'components/CustomButtons/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import moment from 'moment';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import BackButton from 'components/BackButton'
import {apiRequest} from 'util/api/util'
import {canceledReservationForClass} from 'store/actions/schedulingActions'
import AddNewStudent from "components/ClassDashboard/AddNewStudent";
import {fetchReservationData, checkinReservation} from 'store/actions/dashboardActions'

const useStyles = makeStyles(styles);


function ClassDashboard(props) {
    const { history, match } = props;
    const classId = match.params.platformID
    const classes = useStyles();
    const user = useSelector(state => state.user.userData)

    // const [reservations, setReservations] = React.useState([])

    const reservations = useSelector(state => state.instructor.reservations.filter(val => {
        return val.classId === classId
    }))
    const [isLoading, setIsLoading] = React.useState(false)
  
    console.log("Match: " + match)

    moment.locale('en', {
        calendar : {
            lastDay : '[Yesterday,] LL',
            sameDay : '[Today,] LL',
            nextDay : '[Tomorrow,] LL',
            lastWeek : '[last] dddd [at] LL',
            nextWeek : 'dddd, LL',
            sameElse : 'dddd MMM Do'
        }
    });

    const dispatch = useDispatch();
    useEffect(() => {

        if (!classId || !user || !user.platformID || reservations.length > 0) {
            console.log("no classId")
            return
        }
        setIsLoading(true)

        dispatch(fetchReservationData(classId))
            .then(val => {
                setIsLoading(false)
            })
        
    }, [user]);

    const handleCheckIn = (reservation) => {
        console.log("Check in with reservations: ", reservation)
        const checkInStatusBefore = reservation.checkedIn ?? false
        const checkInStatusAfter = !checkInStatusBefore
        const reservationId = reservation.id

        if (!reservationId) {
            window.alert("Error checking in, please try again")
            return
        }

        // const partnerId = user.platformID

        
        dispatch(checkinReservation(reservationId, checkInStatusAfter))
    }

    const allClasses = useSelector(state => state.instructor.classes);
    const selectedClass = allClasses.find(val => val.platformID === classId)
    console.log("Selected class: ", selectedClass)


    const [showShareLink, setShareLink] = useState(false);
    function handleShareClass(e) {
        e.preventDefault()
        window.branch.link({
        tags: ['class'],
        channel: 'website',
        feature: 'widget',
        data: {
            shareType: "class",
            platformID: selectedClass.platformID
        }
        }, function(err, link) {
        setShareLink(true);
        var input = document.createElement('input');
        input.setAttribute('value', link);
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        setTimeout(function() {
            setShareLink(false);
        }, 2000);
        });
    }

    function handleEmailClass(e) {
        e.preventDefault()
        const emails = reservations.filter(val => {
            if (val.canceled) {
                return false
            }
            return true
        }).map(val => {
            if (val.user && val.user.email) {
                return val.user.email
            }
            return val.customer_email
        })
        const mailTo = `mailto:?bcc=${emails.join(',')}`
        window.open(
            mailTo
        )
    }

    const viewModel = {
        reserved: selectedClass?.total_booked ?? '~',
        checkedIn: reservations.filter(val => val?.checkedIn).length
    }

    const START_TIME = selectedClass ? moment(selectedClass.start_time * 1000) : moment()
    const END_TIME = START_TIME.clone().add(selectedClass?.duration ?? 60, 'minutes')

    return (
        <div className="container px-0">
            <BackButton className="mb-3" />
        { selectedClass && (
                <Card className="p-0">
                <CardHeader className="d-flex d-row align-items-center">
                    {selectedClass.images && selectedClass.images.length > 0 && (
                    <CardAvatar plain>
                        <img src={selectedClass.images[0]} alt="..." />
                    </CardAvatar>
                    )}
                    <div>
                    <h4>{START_TIME.format("LT")} - {END_TIME.format("LT")}</h4>
                    <h6>{selectedClass.class_name || selectedClass.name}</h6>
                    <h6>{START_TIME.calendar()} with {selectedClass?.host_name}</h6>
                    

                    </div>
                </CardHeader>
                <CardBody>
                    <h4><strong>Reserved:&nbsp;</strong>{viewModel.reserved}&nbsp;&nbsp;<strong>Checked in:&nbsp;</strong>{viewModel.checkedIn}</h4>
                    
                    <div className="d-flex d-row align-items-center">
                        <button className="btn btn-primary mr-2" onClick={handleEmailClass} color="primary">Email Students</button>
                        
                    </div>
                </CardBody>
                <CardBody>
                    <AddNewStudent 
                        classId={classId}
                        selectedClass={selectedClass}
                    />
                </CardBody>
                <CardBody>
                    <ClassAttendanceTable isLoading={isLoading} onCheckIn={handleCheckIn} selected_class={selectedClass} reservations={reservations} />
                </CardBody>
                </Card>
        )}
        </div>
    );
}

export default ClassDashboard;
